import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import { Url, URLS } from '@wix/da-url';
import BurgerIcon from '../../../Icons/Burger';
import { BiEventType, BiLink } from '../../../biLogger';
import SearchButton from '../SearchButton';
import SubmitMenu from './SubmitMenu';
import s from './BurgerMenu.scss';
var BurgerMenu = /** @class */ (function (_super) {
    tslib_1.__extends(BurgerMenu, _super);
    function BurgerMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isBurgerMenuOpened: false,
            isSubmitMenuOpened: false,
        };
        _this.toggleBurgerMenu = function (flag) {
            var newState = flag !== undefined ? flag : !_this.state.isBurgerMenuOpened;
            if (document && document.documentElement) {
                // Prevent scrolling when menu is open
                if (newState) {
                    document.body.style.overflow = 'hidden';
                    document.documentElement.style.overflow = 'hidden';
                    document.documentElement.style.height = '100%';
                    document.documentElement.style.position = 'relative';
                }
                else {
                    document.body.style.overflow = 'auto';
                    document.documentElement.style.overflow = 'auto';
                    document.documentElement.style.height = 'initial';
                    document.documentElement.style.position = 'initial';
                }
            }
            _this.setState({
                isBurgerMenuOpened: newState,
                isSubmitMenuOpened: false,
            });
        };
        _this.toggleSubmitMenu = function () {
            _this.setState({
                isSubmitMenuOpened: !_this.state.isSubmitMenuOpened,
            });
        };
        _this.handleClickSearchButton = function () {
            _this.toggleBurgerMenu(false);
            _this.props.onOpenMobileSearch();
        };
        _this.handleToggle = function () {
            _this.toggleBurgerMenu();
        };
        return _this;
    }
    BurgerMenu.prototype.render = function () {
        var _a = this.props, t = _a.t, activeMainMenuItem = _a.activeMainMenuItem, watchCount = _a.watchCount, _b = _a.redirectOnSubmit, redirectOnSubmit = _b === void 0 ? false : _b, pushModal = _a.pushModal, isLoggedIn = _a.isLoggedIn;
        var _c = this.state, isBurgerMenuOpened = _c.isBurgerMenuOpened, isSubmitMenuOpened = _c.isSubmitMenuOpened;
        var menuItems = [
            {
                key: 'siteHeader.browse',
                url: Url.browseHomeLink(),
            },
            isLoggedIn && {
                key: 'siteHeader.watch',
                notification: watchCount > 0,
                url: Url.watchLink(),
            },
            {
                key: 'siteHeader.groups',
                url: URLS.GROUPS,
            },
            {
                key: 'siteHeader.forum',
                url: URLS.FORUM,
            },
            {
                key: 'siteHeader.helpAndFAQ',
                url: URLS.HELP,
            },
        ];
        return (React.createElement("div", { className: classnames(s['burger-menu-wrapper'], isBurgerMenuOpened && s['is-opened']) },
            React.createElement("div", { className: s['burger-menu-shade'], onClick: this.handleToggle }),
            React.createElement("div", { className: s['burger-icon-button'], onClick: this.handleToggle },
                React.createElement(BurgerIcon, { className: s['burger-icon'], disableDefaultColors: true })),
            React.createElement("div", { className: s['burger-menu'] },
                React.createElement("div", { className: s['burger-search-button'] },
                    React.createElement(SearchButton, { className: s['icon-button'], iconClassName: s['search-icon'], onClick: this.handleClickSearchButton })),
                React.createElement("ul", { className: classnames(s['main-menu'], isSubmitMenuOpened && s['list-items--disabled']) }, menuItems.map(function (menuItem) {
                    return menuItem && (React.createElement("li", { key: menuItem.key },
                        React.createElement(BiLink, { biData: {
                                evid: BiEventType.TOP_NAV_CLICK,
                                link_url: menuItem.url,
                                link_name: menuItem.key.split('.')[1],
                                indicator: typeof menuItem.notification !== 'undefined'
                                    ? Number(menuItem.notification)
                                    : undefined,
                            }, href: menuItem.url, className: classnames(s['list-item'], menuItem.key === activeMainMenuItem && s['active']) },
                            React.createElement("span", { className: classnames(menuItem.notification && s['notification']) }, t(menuItem.key)))));
                })),
                React.createElement(SubmitMenu, { isOpen: isSubmitMenuOpened, redirectOnSubmit: redirectOnSubmit, pushModal: pushModal, onToggle: this.toggleSubmitMenu }))));
    };
    BurgerMenu.prototype.handleClickOutside = function (evt) {
        if (this.state.isBurgerMenuOpened || this.state.isSubmitMenuOpened) {
            this.toggleBurgerMenu(false);
        }
    };
    return BurgerMenu;
}(React.Component));
export default withTranslation()(onClickOutside(BurgerMenu));
//# sourceMappingURL=BurgerMenu.js.map